import * as React from 'react';

export const mkContext = <T extends unknown>() =>
  React.createContext<T>(
    // This is `undefined` and typecasted on purpose.
    // See https://github.com/DefinitelyTyped/DefinitelyTyped/pull/24509#issuecomment-382213106
    undefined as unknown as T
  );
